module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "open": true,
      "dialogClass": "dialog-class train-plan-wrap",
      "bodyClass": "train-plan-body"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('trainMenu', {
    ref: "trainmenu",
    attrs: {
      "trainCategories": _vm.trainCategories,
      "isModal": _vm.isModal
    },
    on: {
      "category-path-updated": _vm.onTrainCategoryChoose
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "40px",
      "height": "420px",
      "overflow-y": "auto"
    }
  }, [(_vm.fetchGame) ? _c('mu-circular-progress', {
    staticClass: "demo-circular-progress",
    staticStyle: {
      "position": "absolute",
      "left": "50%",
      "top": "50%"
    },
    attrs: {
      "stroke-width": 5,
      "size": 48
    }
  }) : _vm._e(), _vm._v(" "), (_vm.noTrain) ? _c('div', {
    staticClass: "no-train"
  }, [_vm._v("更多训练敬请期待")]) : _vm._e(), _vm._v(" "), (!_vm.fetchGame) ? _c('card-list', {
    attrs: {
      "isModal": _vm.isModal,
      "listItems": _vm.currentTrainCategory ? _vm.sortGame(_vm.currentTrainCategory.games) : [],
      "itemComponent": _vm.trainCard
    },
    on: {
      "list-item-clicked": _vm.onTrainClicked
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "right": "0",
      "background-color": "#fff",
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center",
      "justify-content": "flex-end",
      "padding-bottom": "10px"
    }
  }, [_c('mu-raised-button', {
    staticStyle: {
      "backgroundColor": "#ddd"
    },
    attrs: {
      "label": "取消"
    },
    on: {
      "click": _vm.cancelhandler
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "primary": "",
      "label": ("确定 (" + _vm.len + ")"),
      "disabled": _vm.len === 0
    },
    on: {
      "click": function($event) {
        _vm.confirmHandler(_vm.checkItem)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "40px"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c4ae091!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/case/trainPlan/addMoreModal.vue
// module id = 978
// module chunks = 2